export default __webpack_public_path__ + "static/media/invest.6b7e29c8.svg";